import React from 'react';
import { Tag, Tooltip } from 'antd';
import { CanvassQuoteRecord } from '../../../types/Canvass';

/**
 * One supplier's answer on one item.
 *
 * Three states, deliberately distinct: a price, an explicit "no", and nobody
 * having asked yet. Collapsing the last two would hide which suppliers still
 * owe an answer, which is most of what a half-finished canvass is telling you.
 */
const QuoteCell = ({
  quote,
  awarded,
  editable,
  onClick,
}: {
  quote?: CanvassQuoteRecord;
  awarded: boolean;
  editable: boolean;
  onClick: () => void;
}) => {
  const body = (() => {
    if (!quote || quote.available === null || quote.available === undefined) {
      return <span className={'text-gray-400'}>not asked</span>;
    }
    if (!quote.available) {
      return <Tag>no</Tag>;
    }
    return (
      <span>
        {quote.quotedPrice ?? '—'}
        {quote.leadTimeDays != null && (
          <span className={'text-gray-400'}> · {quote.leadTimeDays}d</span>
        )}
      </span>
    );
  })();

  return (
    <Tooltip title={editable ? 'Click to record what this supplier said' : quote?.remarks}>
      <div
        onClick={editable ? onClick : undefined}
        className={[
          'px-2 py-1 rounded',
          editable ? 'cursor-pointer hover:bg-gray-100' : '',
          awarded ? 'bg-green-50 font-semibold' : '',
        ].join(' ')}
      >
        {body}
      </div>
    </Tooltip>
  );
};

export default QuoteCell;
